import { render, staticRenderFns } from "./EnvioEmailPersonalizado.vue?vue&type=template&id=620d2be6&scoped=true&"
import script from "./EnvioEmailPersonalizado.vue?vue&type=script&lang=js&"
export * from "./EnvioEmailPersonalizado.vue?vue&type=script&lang=js&"
import style0 from "./EnvioEmailPersonalizado.vue?vue&type=style&index=0&id=620d2be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d2be6",
  null
  
)

export default component.exports